export default {
  header:{
    text1:'หน้าแรก',
    text2:'เกี่ยวกับ',
    text3:'เกม',
  },
  banner:{
    text1:'สร้างเกมที่ดีกว่า',
    text2:'เรากำลังสร้างประสบการณ์การเล่นเกมที่ดียิ่งขึ้น โดยผสมผสานนวัตกรรมเข้ากับคุณภาพระดับสูง เพื่อมอบความสนุกสนานและความเพลิดเพลินให้กับผู้เล่น',
    text3:'เรียนรู้เพิ่มเติม',
    text4:'ยินดีต้อนรับสู่ S1',
    text5:'พอร์ตโฟลิโอเกมสล็อตที่ได้รับรางวัลของเราเต็มไปด้วยเนื้อหาเฉพาะตัวที่พัฒนาภายในองค์กร ประกอบด้วยเกมหลากหลายที่รองรับหลายสกุลเงิน',
    text6:'เล่นเลย',
  },
  about:{
    txt1:'เกี่ยวกับเรา',
    txt2:'นี่คือเรื่องราวของเรา',
    txt3:'เรา คือ S1 Gaming',
    txt4:'ความหลงใหลในการเล่นเกมของเราไร้ขีดจำกัด',
    txt5:'ที่ S1 Gaming เราให้ความสำคัญกับนวัตกรรมและผลักดันขอบเขตในอุตสาหกรรมเกมมากว่า 10 ปี เป้าหมายของเราคือการนำเสนอเกมที่มีประสิทธิภาพสูงสุด พร้อมกราฟิกคุณภาพสูง กลไกที่สร้างสรรค์ และการมีส่วนร่วมของผู้เล่นที่แข็งแกร่ง S1 Gaming ให้ความสำคัญกับความหลากหลายของเกม โดยนำเสนอเกมในธีมและกลไกที่หลากหลายซึ่งเหมาะกับผู้เล่นทั่วโลก',
    text6:'คุณสมบัติที่น่าทึ่ง',
    text7:'คุณสมบัติผลิตภัณฑ์เกม',
    text8:'เกมคุณภาพสูง',
    text9:'ออกแบบภายในด้วยศิลปะการโต้ตอบระดับแนวหน้า',
    text10:'ความยุติธรรม',
    text11:'กลไกเกมที่ยุติธรรมและความผันผวนของตัวเลขที่มีเสถียรภาพ',
    text12:'หลายแพลตฟอร์ม',
    text13:'รองรับเบราว์เซอร์ยอดนิยมและระบบปฏิบัติการส่วนใหญ่',
    text14:'การผสานรวม API',
    text15:'เอกสารทางเทคนิคโดยละเอียด ที่ช่วยให้พันธมิตรมีขั้นตอนการเชื่อมต่อที่ราบรื่น',
  },
  home:{
    text1:'สมบูรณ์ที่สุด',
    text2:'คอลเลกชันเกม',
    text3:'ใหม่',
    text4:'เร็ว ๆ นี้',
    text5:'ดูเกมทั้งหมด',
    text6:'',
  },
  message: {
    text1: 'เกม',
    text2: 'คุณสมบัติผลิตภัณฑ์เกม',
    text4: 'Lucky Gaming มีผู้เชี่ยวชาญที่มีประสบการณ์ในเทคโนโลยีการเขียนโปรแกรม วิสัยทัศน์ด้านศิลปะ วิศวกรรมตัวเลข และสาขาอื่น ๆ อีกมากมาย โดยได้ขยายทีมอย่างต่อเนื่องเพื่อพัฒนาเกมที่มีเอกลักษณ์เฉพาะตัวจำนวนมาก และมุ่งมั่นที่จะเป็นแบรนด์เกมที่มีการแข่งขันสูงที่สุด',
    text5: 'เกมคุณภาพสูง',
    text6: 'ออกแบบภายในด้วยศิลปะการโต้ตอบระดับแนวหน้า',
    text7: 'ความยุติธรรม',
    text8: 'กลไกเกมที่ยุติธรรมและความผันผวนของตัวเลขที่มีเสถียรภาพ',
    text9: 'หลายแพลตฟอร์ม',
    text10: 'รองรับเบราว์เซอร์ยอดนิยมและระบบปฏิบัติการส่วนใหญ่',
    text11: 'การผสานรวม API',
    text12: 'เอกสารทางเทคนิคโดยละเอียด ที่ช่วยให้พันธมิตรมีขั้นตอนการเชื่อมต่อที่ราบรื่น',
    text13: 'หน้าแรก',
    text14: 'เข้าสู่ระบบ',
    text15: 'บัญชี',
    text16: 'รหัสผ่าน',
    text17: 'เกมเด่น',
    text18: 'เล่น',
    text19: 'ไม่มีข้อมูล',
    text20: 'เร็ว ๆ นี้้',
    text21: 'Lucky Gaming ต้นฉบับ',
    text22: 'ยินดีต้อนรับสู่หมวดคาสิโนออนไลน์ที่น่าทึ่งที่สุด',
    text23: 'นี่คือคอลเลกชันที่สร้างขึ้นโดยนักพัฒนา Lucky Gaming เพื่อคุณโดยเฉพาะ!',
    text24: 'กำลังโหลด',
    text25: '',
    text26: '',
  },
  games:{
    text1: "เจมส์ ออฟ โอลิมปัส",
    text2: "ไพ่นกกระจอก ทองคำ 2",
    text3: "ไฟร์บอล เดย์ ออฟ เดอะ เดด",
    text4: "โกลเด้น ไมเนอร์",
    text5: "ซาฟารี เวิลด์",
    text6: "ขุมทรัพย์คลีโอพัตรา",
    text7: "ตำนานแห่งอียิปต์",
    text8: "ไฟร์บอล จูราสสิก",
    text9: "ฮาวาย พาราไดซ์",
    text10: "สปีดคิง",
    text11: "ไฟร์บอล คเณศ",
    text12: "กลาดิเอเตอร์",
  },
  seo: {
    logo: 'ที่ S1 Gaming เราเชื่อมั่นในนวัตกรรมและได้ก้าวข้ามขีดจำกัดในอุตสาหกรรมเกมมานานกว่าทศวรรษ เป้าหมายของเราคือการมอบเกมที่มีประสิทธิภาพสูงสุด พร้อมด้วยการออกแบบกราฟิกคุณภาพสูง กลไกเกมที่สร้างสรรค์ และการมีส่วนร่วมของผู้เล่นที่แข็งแกร่ง S1 Gaming ให้ความสำคัญกับพอร์ตโฟลิโอเกมที่หลากหลาย โดยนำเสนอเกมระดับโลกที่มีธีมและกลไกที่แตกต่างกัน',
    game1: 'การออกแบบที่โดดเด่นของ Gems of Olympus ส่องประกายด้วยความหรูหรา ผสมผสานองค์ประกอบจากตำนานเทพเจ้ากรีกโบราณ',
    game2: 'การผสมผสานระหว่างมังกรทองและไพ่นกกระจอก เป็นตัวแทนของโชคลาภและความโชคดีในวัฒนธรรมจีนดั้งเดิม',
    game3: 'ลูกไฟแห่งวันแห่งความตายที่ร้อนแรง ผสานกับเงามืดของคืนฮาโลวีน สร้างบรรยากาศเทศกาลที่เข้มข้น',
    game4: 'ล้อมรอบด้วยแร่ทองคำที่ส่องประกาย เป็นสัญลักษณ์ของความยากลำบากในการทำเหมืองทองและผลตอบแทนที่อุดมสมบูรณ์',
    game5: 'ทิวทัศน์อันตระการตาของทวีปแอฟริกา ประกอบด้วยทุ่งหญ้า สัตว์ป่า และพระอาทิตย์ตกดิน สร้างบรรยากาศธรรมชาติที่สงบงามและยิ่งใหญ่',
    game6: 'เครื่องประดับอันวิจิตรและโบราณวัตถุใน Cleopatra’s Treasure เป็นตัวแทนของความหรูหราและความลึกลับของอียิปต์โบราณ',
    game7: 'เทพเจ้าและสัญลักษณ์โบราณใน Egyptian Legends แสดงให้เห็นถึงพลังและโลกอันลึกลับของตำนานอียิปต์โบราณ',
    game8: 'ลูกไฟที่ร้อนแรงลอยผ่านท้องฟ้ายุคจูราสสิค พร้อมฉากหลังของฝูงไดโนเสาร์และป่าโบราณ เต็มไปด้วยความลึกลับยุคก่อนประวัติศาสตร์',
    game9: 'ชายหาดสวรรค์แห่งฮาวาย ผสมผสานระหว่างน้ำทะเลสีฟ้าและหาดทรายขาว กับต้นปาล์มที่แกว่งไกลในระยะไกล นำเสนอภาพอันสงบของสวรรค์เขตร้อน',
    game10: 'รถแข่งของ Speed King พุ่งผ่านสนามแข่งทิ้งรอยยางที่ร้อนระอุ แสดงถึงความเร็วและพลังที่ไม่มีใครเทียบได้',
    game11: 'ในแสงไฟที่เจิดจ้าของลูกไฟ ภาพขนาดใหญ่ของพระพิฆเนศประดิษฐานอยู่ตรงกลาง เป็นสัญลักษณ์แห่งโชคลาภและความมั่งคั่ง',
    game12: 'นักรบกลาดิเอเตอร์โบกดาบและโล่ในสนามประลอง ล้อมรอบด้วยบรรยากาศทางประวัติศาสตร์ของโคลอสเซียมโรมันโบราณ เต็มไปด้วยพลังและจิตวิญญาณแห่งการต่อสู้',
  },
  notFound: {
    text1: 'ขออภัย! หน้าที่คุณกำลังค้นหาไม่มีอยู่ กรุณารีเเลด',
    text2: 'กลับไปหน้าแรก'
  }
}
